import { render } from "./email-otp.vue?vue&type=template&id=e91624fc&scoped=true"
import script from "./email-otp.vue?vue&type=script&lang=js"
export * from "./email-otp.vue?vue&type=script&lang=js"

import "./email-otp.vue?vue&type=style&index=0&id=e91624fc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e91624fc"]])

export default __exports__